import React from 'react'

import AccessDenied from '@/components/ui/template/AccessDenied'

export type ProtectedPageProps = {
  accessible?: boolean
  children?: React.ReactElement
}

export function ProtectedPage(props: ProtectedPageProps) {
  const { accessible, children } = props
  if (!accessible) return <AccessDenied />

  return children || null
}

export default ProtectedPage
